import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class TrainingSimulatorStaff extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.training_certification_staff_id,
      hours: '',
      double_paid: '',
      status: 0,
    };

    //bind específico
    this.generateCertification = this.generateCertification.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_certification_staff_id !== 'undefined')){
      this.setState({
        hours: newProps.hours,
        status: newProps.status,
        id: newProps.training_certification_staff_id,
      });
    }
  }
  
  // Fetch salvando resultado do aluno
  generateCertification(event) {
    event.preventDefault();
    if (window.confirm('Tem certeza que deseja gerar o certificado desse instrutor?')) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.id,
        hours: this.state.hours,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/instrutor/gerar/certificado', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <form onSubmit={this.generateCertification}>
          <table className="table">
            <thead>
              <tr>
                <th>Horas</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                  <td>
                  <InputMask disabled={this.state.status == 1 ? "disabled" : ""} value={this.state.hours} maskChar={null} name="hours" mask="999" className="form-control" onChange={this.handleChange.bind(this, 'hours')}/>
                  </td>
                  <td>
                    <button disabled={this.state.status == 1 ? "disabled" : ""} type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-file-pdf-o"></i> Gerar certificado</button>
                  </td>
              </tr>
            </tbody>
          </table>
        </form>  
      </div>
    );
  }
}

export default TrainingSimulatorStaff;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingStaffPayment.js